import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiciosService } from 'src/app/services/servicios.service';
import { AlertController, LoadingController, Platform } from '@ionic/angular';
import { Device } from '@ionic-native/device/ngx';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-historico',
  templateUrl: './historico.page.html',
  styleUrls: ['./historico.page.scss'],
})
export class HistoricoPage implements OnInit {
  controlTiempo:Boolean = false;
  nombre_usuario:string;
  historico:any = [];
  empleado_id: number;
  mensajeEliminado: any;
  loading:any;
  pagina:number;
  mensaje:string ='';
  auxiliar: any;
  multiEmpresa: any;
  historicoMultiEmpresa:any;


  public codigoColor = environment.personalizado.codigoColor;

  constructor(private rutaActiva: ActivatedRoute, 
              private router: Router,
              private serv: ServiciosService,
              private dev: Device,
              private plat: Platform,
              private alertCtrl: AlertController,
              private loadingCtrl:LoadingController,
              private auth: AuthService) {  }

  async ngOnInit() {
  }
  async ionViewWillEnter(){
    this.auth.sigueEnSesion();
    this.nombre_usuario = this.rutaActiva.snapshot.params.nombre;
    this.empleado_id = this.rutaActiva.snapshot.params.id;
    this.pagina = 1;
    this.mensaje = '';
    this.historico = [];
    await this.obtenerMultiEmpresa();
    this.buscaHistorico(null);

  }
  buscaHistorico(event:any){
    if (this.multiEmpresa){
      this.getMultiHistorico(event)
    } else {
      this.getHistorico(event);
    }
  }
  async getMultiHistorico(event:any){
    this.historicoMultiEmpresa = [];
    let controlatiempo: any;
    await this.presentLoading('Cargando...');
    await Promise.all(this.multiEmpresa.map(async empresa =>{
      let subscripcions = await new Promise((resolve) => {
        this.serv.getHistorico(this.empleado_id, localStorage.getItem('telefono'), this.pagina,empresa.id).subscribe((h: any) => {
          if (h) {
            h.map(ele=>{
              ele.imagen = empresa.imagen;
              ele.titulo = empresa.titulo;
            })
          }
          this.historicoMultiEmpresa.push(h);
          if (this.loading != null) {
            this.loading.dismiss();
          }
          resolve(h);
        }); 
      });
      console.log(subscripcions,'subscripcions');
    }));
    this.historico=this.historico.concat(this.historicoMultiEmpresa.flat(1).sort((a: any, b: any) => {
      const diff = new Date(b.fecha_time).getTime() - new Date(a.fecha_time).getTime();
      if (diff == 0) {
        if (a.e_s === 'E') return -1;
        if (b.e_s === 'E') return 1;
        if (a.e_s === 'S') return -1;
        if (b.e_s === 'S') return 1;
        if (a.e_s === 'F') return -1;
        if (b.e_s === 'F') return 1;
        
        // Si ambos valores son distintos a 'E', 'S' o 'F', se mantienen en su posición relativa
        return 0; 
      } else {
        return diff;
      }
    }));
    if(event != null){
      event.target.complete();
    }
    if ((this.loading != null) && (this.loading != undefined)) {
      this.loading.dismiss();
    }
  }
  async getHistorico(event:any){  
    this.controlTiempo = false;
    let controlatiempo: any;
    await this.presentLoading('Cargando...');
    let subscripcion = this.serv.getHistorico(this.empleado_id, localStorage.getItem('telefono'), this.pagina).subscribe((h) => {
      this.controlTiempo = true;
      clearInterval(controlatiempo);
      this.historico = h;
      if (this.loading != null) {
        this.loading.dismiss();
      }
      if(event != null){
        event.target.complete();
      }
      if (this.historico - length == 0) {
        this.presentAlert('No hay histórico');
      }
    });   
    controlatiempo = setTimeout(() => {
      if (!this.controlTiempo) {
        subscripcion.unsubscribe();
        if ((this.loading != null) && (this.loading != undefined)) {
          this.loading.dismiss();
        }
        this.presentAlert('La conexión esta tardando demasiado, por favor inténtelo de nuevo pasados unos momentos');
      }
    }, 1000 * 10);    
  }
  async presentAlert(mensaje: string) {
    const alert = await this.alertCtrl.create({
      subHeader: mensaje,
      buttons: [{
        text: 'Ok',
        handler: () => {
        }
      }]
    });
    await alert.present();
  }
  editar(id:number, id_plataforma:number,empresa?: number) {
    if (empresa) {
      this.auth.cambiaEmpresa(empresa)
    }
    this.router.navigate(['/marcaje/'+id]);
  }
  doRefresh(event) {
    this.mensaje = '';
    this.getHistorico(event);
  }
  eliminarMarcaje(id:number, id_plat_orig:number, tipo: number, indice:number, empresa?: number){
    this.controlTiempo = false;
    let latitud='';
    let longitud='';
    let wifis =null;
    let wifisconcat='';
    let posicion = null;    
    let fecha_real;
    let aux;
    if (empresa) {
      this.auth.cambiaEmpresa(empresa);
    }
    if(sessionStorage.getItem('wifis')!= null) {
      wifis = JSON.parse(sessionStorage.getItem('wifis'));
    }
    if (sessionStorage.getItem('posicion') != null) {
      posicion = JSON.parse(sessionStorage.getItem('posicion'));
    }
    if (wifis != null) {
      if(wifis.length > 0) {
        for (let index = 0; index < wifis.length; index++) {
          if (wifis.length - 1 == index) {
            wifisconcat += wifis[index].SSID;
          } else {
            wifisconcat += wifis[index].SSID + '$';
          }
        }
      }
    }
    /*Object.keys(posicion).length === 0);  ESTA ES LA FORMA CORRECTA DE VER SI UN JSON ESTA VACIO, SIN NODOS*/
    try {
      if((posicion != null)&&(posicion != undefined)) {
        if ((posicion.coords != null) && (posicion.coords != undefined)) {
          latitud = posicion.coords.latitude;
          longitud = posicion.coords.longitude;
        }
      }
    } catch (e) {
      console.log('Error', e);
    }
    let plataformas = this.plat.platforms();
    let plataforma;
    for (let index = 0; index < plataformas.length; index++) {
      plataforma += plataformas[index]+';';
      
    }
    let subscripcion = this.serv.setEliminaMarcaje(localStorage.getItem('telefono'), latitud, longitud, wifisconcat, plataforma, id, id_plat_orig, tipo).subscribe((men)=>{
      this.controlTiempo = true;
      this.mensajeEliminado = men;      
      if (this.mensajeEliminado.id == 1) {
        this.historico.splice(indice,1);
        //this.historico.filter(historico => historico.id !== this.historico[0].id);
      } else {
        this.presentAlert(this.mensajeEliminado.mensaje);
      }
    });
  }
  salir(){
    this.router.navigate(['/marcaje/0']);
  }
  async presentLoading(message: string) {
    this.loading = await this.loadingCtrl.create({
      message
      // duration: 2000
    });
    return this.loading.present();
  }
  cargarMas(event) {
    this.pagina++;
    setTimeout(() => {
      if (this.multiEmpresa) {
        this.buscaHistorico(event);
      } else {
        this.serv.getHistorico(this.empleado_id, localStorage.getItem('telefono'), this.pagina).subscribe((hist) => {
          this.auxiliar = hist;
          if (this.auxiliar.length > 0) {
            this.historico.push(...this.auxiliar);
            event.target.complete();
          }else {
            this.mensaje = 'No hay mas registros';
            event.target.disabled = true;
          }
        });
      }
    }, 500);


    /*
    setTimeout(() => {

      if (this.data.length > 50) {
        event.target.complete();
        this.infitniteScroll.disabled = true;
        return;
      }

      const nuevoArr = Array(20);
      this.data.push(...nuevoArr);
      event.target.complete();

    }, 1000);
*/
  }
  abrirAyuda() {
    this.serv.abrirAyuda();
  }
  borrarMarcaje(id: number, id_plataforma_orig:number, tipo: string, indice:number){
  
    let tip;
    if((tipo == 'E') || (tipo == 'S')) {
      tip = 0;
    }else {
      tip = 1;
    }
    this.eliminarMarcaje(id, id_plataforma_orig, tip, indice);
  }
  /**
   * Obtenemos los datos de las distintas empresas del usuario.
   */
  async obtenerMultiEmpresa() {
    const multi_empresa = localStorage.getItem('multi_empresa');
    if (multi_empresa) {
      const empresas = multi_empresa.split(',');
      const promesasEmpresas = empresas.map(async empresa => {
        const res: any = await new Promise((resolve, reject) => {
          this.serv.getDatosEmpresas(empresa).subscribe({
            next: valor => resolve(valor),
            error: err => reject(err)
          });
        })
        return {
          id: res.id,
          imagen: `data:image/${res.formato.toLowerCase()};base64,` + res.imagen,
          titulo: res.titulo
        };
      });
    
      return this.multiEmpresa = await Promise.all(promesasEmpresas);
    }
  }
}
